module.exports = [
  code: 'cs'
  name: 'Čeština'
,
  code: 'de'
  name: 'Deutsch'
,
  code: 'en-AU'
  name: 'English (AU)'
,
  code: 'en-GB'
  name: 'English (UK)'
,
  code: 'en-US'
  name: 'English (US)'
,
  code: 'es'
  name: 'Español'
,
  code: 'fr'
  name: 'Français'
,
  code: 'fr-CA'
  name: 'Français (Canada)'
,
  code: 'it'
  name: 'Italiano'
,
  code: 'hu'
  name: 'Magyar'
,
  code: 'nl'
  name: 'Nederlands'
,
  code: 'nb'
  name: 'Norsk (bokmål)'
,
  code: 'pl'
  name: 'Polski'
,
  code: 'pt-BR'
  name: 'Português (Brasil)'
,
  code: 'fi'
  name: 'Suomi'
,
  code: 'sv'
  name: 'Svenska'
,
  code: 'vi'
  name: 'Tiếng Việt'
,
  code: 'tr'
  name: 'Türkçe'
,
  code: 'ru'
  name: 'Русский'
,
  code: 'uk'
  name: 'Українська'
,
  code: 'th'
  name: 'ภาษาไทย'
,
  code: 'zh-Hans'
  name: '中文 (简体)'
,
  code: 'zh-Hant'
  name: '中文 (繁體)'
,
  code: 'ja'
  name: '日本語'
]



// WEBPACK FOOTER //
// ./app/scripts/data/supported-locales.coffee